import { createApp } from 'vue';
import App from './App';
import router from './router';
import store from './store';
import { initIris } from './utils/iris';
import { caInit } from './utils/ca';

// 初始化平台iris
initIris();
// 初始化埋点上报
caInit();
// 启动应用
createApp(App)
  .use(store)
  .use(router)
  .mount('#app');
